module.exports = __webpack_public_path__ + "img/2.198d84ec.jpg";